export default {
    computed: {
        pageModules() {
            return this.$root.moduleData;
        },
        isOverlap() {
            if (!this.pageModules) {
                return this.overlap;
            }
            let forbiddenOverlapFlag = false,
                i = 0,
                m;
            while ((m = this.pageModules[i++])) {
                if (m.name == 'md-search') {
                    forbiddenOverlapFlag = true;
                    break;
                }
            }
            return !forbiddenOverlapFlag && this.overlap;
        }
    }
};
